import { AssetManager } from 'components/sharpr/assetManager/AssetManager';
import { markAsLoggingIn } from '../../../sharpr/auth/AuthInterceptor';

export function UserLoginRoute($stateProvider) {
	'ngInject';
	$stateProvider.state('hub.UserLogin', {
		url: '/login',
		controllerAs: 'vm',
		controller: UserLoginCtrl,
		templateUrl: '/ng/hub/User/Login/UserLoginCtrl.html',
		resolve: {
			style: () => AssetManager.css('/ng/hub/User/Login/UserLoginCtrl.css'),
			$title: () => 'Login',
			allSearchParams: Location => {
				'ngInject';
				const allSearchParams = {
					forwardTo: 'hub.loggedin.PostListing',
					...Location.getAllSearchParams(),
				};
				return allSearchParams;
			},
			isRemembered: ($window, $state, Api, allSearchParams) => {
				'ngInject';
				function forward() {
					let href = $state.href(allSearchParams.forwardTo);
					if (href) {
						href = '/hub';
					}
					window.location.href = href;
				}
				return Api.get('/auth/is_remembered', {}, { Authorization: 'Public' }).then(isRemembered => {
					if (isRemembered) {
						markAsLoggingIn();
						if (/^https?:\/\//i.test(allSearchParams.forwardTo)) {
							$window.location.href = allSearchParams.forwardTo;
						} else {
							if (allSearchParams.forwardTo === 'hub.loggedin.PostListing') {
								Api.get('/config/preferences')
									.then(response => {
										let homePage = response['Features.home_page'];
										//Just in case they are trying to use the classic insights page
										if (response['UI.use_classic_insights_page'] === '1' && homePage.includes('core/insights')) {
											homePage = '/hub#/posts';
										}

										$window.location.href = `${$window.BASE_URL}${homePage}`;
									})
									.catch(forward);
							} else {
								forward();
							}
						}
						return Promise.reject();
					}
				});
			},
			themeData: (Api, allSearchParams) => {
				'ngInject';
				const themeCode = allSearchParams.th || window.DOMAIN_THEME;
				// see if `th` is set in Location
				if (!themeCode || themeCode == 'sharpr') {
					return false;
				}
				return Api.get(`/themes/code/${themeCode}`, {}, { Authorization: 'Public' });
			},
		},
	});
}

export class UserLoginCtrl {
	constructor(themeData, allSearchParams) {
		'ngInject';
		this.themeData = themeData;
		this.forwardTo = allSearchParams.forwardTo;
		this.prompt = allSearchParams.authmsg;
	}
}
